
import React from "react";

export default function Footer() {
  return <footer>© 2026 Randhir Builders Pvt Ltd. All rights reserved.</footer>;
}
